import React from 'react';

export function SaveAlternativeIcon({
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 48 48"
      {...props}
    >
      <path d="M38 24v14H10V24H6v14c0 2.2 1.8 4 4 4h28c2.2 0 4-1.8 4-4V24h-4zm-12 1.34l5.18-5.16L34 23 24 33 14 23l2.82-2.82L22 25.34V6h4v19.34z" />
    </svg>
  );
}
